import { render, staticRenderFns } from "./SidebarToolboxes.vue?vue&type=template&id=8e138d72&"
import script from "./SidebarToolboxes.vue?vue&type=script&lang=js&"
export * from "./SidebarToolboxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports